/* eslint-disable max-len */
/* eslint-disable */
export const REGEX_PHONE = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
export const REGEX_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_MEMBER_NUMBER = /^[0-9]+$/;
export const REGEX_AMOUNT = /^\d+\.\d{2}$/;
export const REGEX_POSTAL_CODE = /^[A-Za-z0-9][A-Za-z0-9\- ]{0,10}[A-Za-z0-9]$/;

export const FIRST_NAME = {
  autocomplete: 'given-name',
  error: '',
  id: 'first-name',
  'data-ui': 'first-name',
  label: 'First name',
  name: 'firstName',
  required: true,
  value: '',
};

export const LAST_NAME = {
  autocomplete: 'family-name',
  error: '',
  id: 'last-name',
  'data-ui': 'last-name',
  label: 'Last name',
  name: 'lastName',
  required: true,
  value: '',
};

export const MEMBER_NUMBER = {
  error: '',
  label: 'Member number',
  id: 'member-number',
  'data-ui': 'member-number',
  inputmode: 'numeric',
  maxLength: 9,
  name: 'memberNumber',
  required: true,
  type: 'number',
  value: '',
};

export const EMPLOYEE_NUMBER = {
  error: '',
  label: 'Employee number',
  id: 'employee-number',
  'data-ui': 'employee-number',
  inputmode: 'numeric',
  name: 'employeeNumber',
  required: true,
  type: 'number',
  value: '',
};

export const PHONE_NUMBER = {
  autocomplete: 'tel',
  error: '',
  id: 'phone-number',
  'data-ui': 'phone-number',
  inputmode: 'tel',
  label: 'Phone number',
  name: 'phoneNumber',
  required: true,
  type: 'tel',
  value: '',
};

export const EMAIL = {
  autocomplete: 'email',
  error: '',
  id: 'email-address',
  'data-ui': 'email-address',
  inputmode: 'email',
  label: 'Email address',
  name: 'emailAddress',
  required: true,
  type: 'email',
  value: '',
};

export const ADDRESS_1 = {
  autocomplete: 'address-line1',
  error: '',
  id: 'address1',
  'data-ui': 'address1',
  label: 'Address 1',
  name: 'address1',
  required: true,
  value: '',
};

export const ADDRESS_2 = {
  autocomplete: 'address-line2',
  error: '',
  id: 'address2',
  'data-ui': 'address2',
  label: 'Address 2',
  name: 'address2',
  required: false,
  value: '',
};

export const CITY = {
  autocomplete: 'address-level2',
  error: '',
  id: 'city',
  'data-ui': 'city',
  label: 'City',
  name: 'city',
  required: true,
  value: '',
};

export const STATE = {
  autocomplete: 'address-level1',
  error: '',
  id: 'state',
  'data-ui': 'state',
  label: 'State',
  name: 'state',
  required: true,
  value: '',
};

export const COUNTRY = {
  autocomplete: 'country',
  error: '',
  id: 'country',
  'data-ui': 'country',
  label: 'Country',
  name: 'country',
  required: true,
  value: '',
};

export const POSTAL_CODE = {
  autocomplete: 'postal-code',
  error: '',
  id: 'postalCode',
  'data-ui': 'postalCode',
  label: 'Postal Code',
  name: 'postalCode',
  required: true,
  value: '',
};

export const REGISTER_NUMBER = {
  error: '',
  label: 'Register number',
  id: 'register-number',
  'data-ui': 'register-number',
  inputmode: 'numeric',
  maxLength: 3,
  name: 'registerNumber',
  required: true,
  value: '',
};

export const STORE_NUMBER = {
  error: '',
  label: 'Store number',
  id: 'store-number',
  'data-ui': 'store-number',
  inputmode: 'numeric',
  maxLength: 3,
  name: 'storeNumber',
  required: true,
  value: '',
};

export const TRANSACTION_NUMBER = {
  error: '',
  label: 'Transaction number',
  id: 'transaction-number',
  'data-ui': 'transaction-number',
  inputmode: 'numeric',
  maxLength: 4,
  name: 'transactionNumber',
  required: true,
  value: '',
};

export const PURCHASE_DATE = {
  error: '',
  label: 'Purchase Date',
  id: 'purchase-date',
  'data-ui': 'purchase-date',
  name: 'purchaseDate',
  required: true,
  type: 'date',
  value: '',
};

export const PURCHASE_AMOUNT = {
  error: '',
  label: 'Purchase amount',
  id: 'purchase-amount',
  'data-ui': 'purchase-amount',
  name: 'purchaseAmount',
  required: true,
  value: '',
};

export const FORM_ERROR_MESSAGES = {
  emailAddress: 'Please enter a valid email',
  phoneNumber: 'Please enter a valid phone number',
  memberNumber: 'Please enter a valid member number',
  address: 'Please enter a valid address',
  purchaseAmount: 'Please enter a valid amount without special characters. e.g. XX.XX',
  postalCode: 'Please enter a valid postal code',
  city: 'Only letters, numbers, spaces, dashes and apostrophes, /, @, #, +, &, and % are allowed',
  default: 'This field is required',
};